import React from "react";

export default function GuestUserForm({
  userName,
  setUserName,
  userEmail,
  setUserEmail,
  userDob,
  setUserDob,
  contactNumber,
  setContactNumber,
  nameError,
  setNameError,
  emailError,
  setEmailError,
  dobError,
  setDobError,
  contactError,
  setContactError,
  minAdultDobIso,
  isValidEmail,
  isValidDob,
  dobInputRef,
  openDobPicker,
}) {
  const blockDobTyping = (e) => {
    const allowedNavigation =
      e.key === "Tab" ||
      e.key === "Escape" ||
      e.key.startsWith("Arrow") ||
      e.key === "Home" ||
      e.key === "End" ||
      (e.ctrlKey && ["a"].includes(e.key.toLowerCase()));
    if (!allowedNavigation) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openDobPicker?.();
        return;
      }
      e.preventDefault();
    }
  };

  /** Pointer/touch: open calendar first; if `showPicker` worked, skip segment focus (Chromium dd/mm UX). */
  const handleDobPointerDown = (e) => {
    const opened = openDobPicker?.() === true;
    if (opened) e.preventDefault();
  };

  return (
    <div className="review-user-form">
      <h4 className="review-user-title">Guest User Details</h4>
      <div className="review-user-field">
        <label htmlFor="reviewUserName">
          User Name <span className="review-required-mark" aria-hidden="true">*</span>
        </label>
        <input
          id="reviewUserName"
          type="text"
          aria-required="true"
          autoComplete="name"
          value={userName}
          onChange={(e) => {
            setUserName(e.target.value);
            if (nameError) setNameError("");
          }}
          onBlur={() => {
            if (!String(userName || "").trim()) setNameError("User name is required.");
          }}
          placeholder="Enter user name"
        />
        {nameError ? <span className="review-field-error">{nameError}</span> : null}
      </div>
      <div className="review-user-field">
        <label htmlFor="reviewUserEmail">
          User Email <span className="review-required-mark" aria-hidden="true">*</span>
        </label>
        <input
          id="reviewUserEmail"
          type="email"
          aria-required="true"
          autoComplete="email"
          value={userEmail}
          onChange={(e) => {
            setUserEmail(e.target.value);
            if (emailError) setEmailError("");
          }}
          onBlur={() => {
            const v = String(userEmail || "").trim();
            if (!v) setEmailError("User email is required.");
            else if (!isValidEmail(v)) setEmailError("Please enter a valid email address.");
          }}
          placeholder="Enter user email"
        />
        {emailError ? <span className="review-field-error">{emailError}</span> : null}
      </div>
      <div className="review-user-field">
        <label
          htmlFor="reviewUserDob"
          onClick={(e) => {
            e.preventDefault();
            openDobPicker?.();
          }}
        >
          Date of Birth <span className="review-required-mark" aria-hidden="true">*</span>
        </label>
        <div className="review-dob-input-wrap">
          <input
            ref={dobInputRef}
            id="reviewUserDob"
            type="date"
            inputMode="none"
            autoComplete="bday"
            className="review-dob-input"
            aria-required="true"
            max={minAdultDobIso}
            value={userDob}
            onPointerDown={handleDobPointerDown}
            onKeyDown={blockDobTyping}
            onPaste={(ev) => ev.preventDefault()}
            onDrop={(ev) => ev.preventDefault()}
            onChange={(e) => {
              setUserDob(e.target.value);
              if (dobError) setDobError("");
            }}
            onBlur={() => {
              const v = String(userDob || "").trim();
              if (!v) setDobError("Date of birth is required.");
              else if (!isValidDob(v)) setDobError("User must be at least 18 years old.");
            }}
          />
        </div>
        {dobError ? <span className="review-field-error">{dobError}</span> : null}
      </div>
      <div className="review-user-field">
        <label htmlFor="reviewContactNumber">
          Contact Number <span className="review-required-mark" aria-hidden="true">*</span>
        </label>
        <input
          id="reviewContactNumber"
          type="tel"
          aria-required="true"
          autoComplete="tel"
          inputMode="numeric"
          pattern="^\+1\s\(\d{3}\)\s\d{3}-\d{4}$"
          value={contactNumber}
          onChange={(e) => {
            setContactNumber(e.target.value);
            if (contactError) setContactError("");
          }}
          onBlur={() => {
            if (!String(contactNumber || "").trim()) setContactError("Contact number is required.");
          }}
          placeholder="+1 (443) 432-4324"
        />
        {contactError ? <span className="review-field-error">{contactError}</span> : null}
      </div>
    </div>
  );
}
